import theme from '@clad-ui/theme';
import { css } from 'linaria';
const {
  colors,
  radii,
  fontSizes
} = theme;
const buttonClass = "bgcbfpj";
export default buttonClass;

require("../../../../../../../.linaria-cache/node_modules/.pnpm/clad-ui@0.20.20_mlt2zq6sucawkuesenn26jlwdu/node_modules/clad-ui/components/Button/Button.styles.linaria.module.css");